import { render, staticRenderFns } from "./CardNote.vue?vue&type=template&id=6567c5c2&"
import script from "./CardNote.vue?vue&type=script&lang=js&"
export * from "./CardNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports